(function () {
  function init() {
    var widget = document.getElementById('juo-subscription-widget');
    if (!widget || !widget.classList.contains('taio-juo')) return;

    var juoDataEl = document.getElementById('juo-subscription-widget-data');
    var taioDataEl = document.getElementById('taio-juo-widget-data');
    if (!juoDataEl || !taioDataEl) return;

    var juoData;
    var taioData;
    try {
      juoData = JSON.parse(juoDataEl.textContent);
      taioData = JSON.parse(taioDataEl.textContent);
    } catch (e) {
      return;
    }

    var variants = juoData[0] || [];
    var currentVariantId = String(juoData[1]);

    var otpPriceEl = widget.querySelector('[data-taio-otp-price]');
    var otpDailyEl = widget.querySelector('[data-taio-otp-daily]');
    var subDailyEl = widget.querySelector('[data-taio-sub-daily]');
    var subPriceEl = widget.querySelector('[data-taio-sub-price]');
    var subCompareEl = widget.querySelector('[data-taio-sub-compare]');
    var savingsEl = widget.querySelector('[data-taio-savings]');
    var btnPriceEl = document.querySelector('product-form .button__price-value');
    var dropdown = widget.querySelector('[data-taio-dropdown]');
    var trigger = widget.querySelector('.taio-freq-trigger');
    var triggerLabel = widget.querySelector('[data-taio-freq-label]');
    var errorEl = widget.querySelector('[data-taio-freq-error]');
    var submitBtn = document.querySelector('product-form button[type="submit"]');
    var qtyInput = widget.querySelector('.taio-quantity-input');
    var minusBtn = widget.querySelector('.taio-quantity-minus');
    var plusBtn = widget.querySelector('.taio-quantity-plus');
    var savedOTPQuantity = 1;

    function money(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
    }

    function moneyShort(cents) {
      if (cents % 100 === 0) return (cents / 100) + ' zł';
      return money(cents);
    }

    function getVariant(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    function getDays(id) {
      var vd = taioData.variantDays ? taioData.variantDays[String(id)] : 0;
      if (vd && vd > 0) return { days: vd, prefix: '' };
      if (taioData.productDays && taioData.productDays > 0) {
        return { days: taioData.productDays, prefix: 'od ' };
      }
      return null;
    }

    function isSubMode() {
      var subRadio = widget.querySelector('input[name="mode"][value="subscription"]');
      return subRadio ? subRadio.checked : true;
    }

    function checkedPlanId() {
      var checked = widget.querySelector('input[name="selling-plan-radio"]:checked');
      return checked ? String(checked.value) : '';
    }

    function planPriceFor(variant) {
      if (!variant || !variant.sellingPlans || !variant.sellingPlans.length) return null;
      var id = checkedPlanId();
      if (id) {
        for (var i = 0; i < variant.sellingPlans.length; i++) {
          if (String(variant.sellingPlans[i].id) === id) {
            return variant.sellingPlans[i].price;
          }
        }
      }
      return variant.sellingPlans[0].price;
    }

    function getProductForm() {
      return document.querySelector('product-form form')
        || document.querySelector('form[action*="/cart/add"]');
    }

    function syncSellingPlan() {
      var form = getProductForm();
      if (!form) return;
      var planId = checkedPlanId();
      if (isSubMode() && planId) {
        var input = form.querySelector('input[name="selling_plan"][data-taio-selling-plan]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'selling_plan';
          input.setAttribute('data-taio-selling-plan', '');
          form.appendChild(input);
        }
        input.value = planId;
      } else {
        form.querySelectorAll('input[name="selling_plan"]').forEach(function (el) {
          el.remove();
        });
      }
    }

    function needsPlan() {
      return isSubMode() && !checkedPlanId();
    }

    function showError(show) {
      if (errorEl) errorEl.classList.toggle('is-visible', show);
    }

    function qty() {
      return qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    }

    function render() {
      syncSellingPlan();
      var variant = getVariant(currentVariantId);
      if (!variant) return;
      var planPrice = planPriceFor(variant);
      if (otpPriceEl) otpPriceEl.textContent = money(variant.price * qty());
      if (subPriceEl) subPriceEl.textContent = money(planPrice || variant.price);
      if (subCompareEl) {
        subCompareEl.textContent = money(variant.price);
        subCompareEl.style.display = planPrice && planPrice < variant.price ? '' : 'none';
      }
      if (savingsEl) {
        var savingsPrefix = savingsEl.getAttribute('data-taio-savings-prefix') || '';
        if (planPrice && planPrice < variant.price) {
          var savingAmount = variant.price - planPrice;
          savingsEl.textContent = (savingsPrefix ? savingsPrefix + ' ' : '') + money(savingAmount);
          savingsEl.style.display = '';
        } else {
          savingsEl.style.display = 'none';
        }
      }
      var hasPlan = isSubMode() && checkedPlanId() && planPrice;
      var btnCents = hasPlan ? planPrice : variant.price * qty();
      if (btnPriceEl) {
        btnPriceEl.textContent = moneyShort(btnCents);
      }
      var stickyPriceEl = document.querySelector('[data-taio-sticky-price]');
      if (stickyPriceEl) {
        stickyPriceEl.textContent = moneyShort(btnCents);
      }
      var d = getDays(currentVariantId);
      if (!d) return;
      if (otpDailyEl) {
        otpDailyEl.textContent = d.prefix + money(variant.price / d.days) + '/dzień';
      }
      if (subDailyEl && planPrice) {
        subDailyEl.textContent = d.prefix + money(planPrice / d.days) + '/dzień';
      }
    }

    function setModeClass() {
      var isSub = isSubMode();
      widget.classList.toggle('taio-mode-sub', isSub);
      widget.classList.toggle('taio-mode-otp', !isSub);
    }

    function closeDropdown() {
      if (!dropdown) return;
      dropdown.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    function openDropdown() {
      if (!dropdown) return;
      dropdown.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    function syncFreq() {
      var any = false;
      widget.querySelectorAll('.taio-freq-option').forEach(function (option) {
        var input = option.querySelector('input');
        var checked = !!input && input.checked;
        option.classList.toggle('taio-freq-option--on', checked);
        if (checked) {
          any = true;
          if (triggerLabel) {
            var label = option.querySelector('.j-selling-plan-label');
            if (label) triggerLabel.textContent = label.textContent.trim();
          }
        }
      });
      if (!any && triggerLabel) {
        triggerLabel.textContent = triggerLabel.getAttribute('data-taio-placeholder') || '';
      }
      if (trigger) trigger.classList.toggle('is-placeholder', !any);
    }

    function syncQuantity(value) {
      var shopifyQuantityInput = document.querySelector('quantity-input');
      if (shopifyQuantityInput) {
        var mainInput = shopifyQuantityInput.querySelector('input[name="quantity"]');
        if (mainInput) {
          mainInput.value = value;
          if (typeof shopifyQuantityInput.onInputChange === 'function') {
            shopifyQuantityInput.onInputChange();
          }
          mainInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
        if (!input.classList.contains('taio-quantity-input')) {
          input.value = value;
        }
      });
    }

    widget.querySelectorAll('input[name="mode"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (this.value === 'subscription' && this.checked && qtyInput) {
          savedOTPQuantity = qty();
          syncQuantity(1);
        }
        if (this.value === 'otp' && this.checked) {
          closeDropdown();
          showError(false);
          if (qtyInput) {
            qtyInput.value = savedOTPQuantity;
            syncQuantity(savedOTPQuantity);
          }
        }
        setModeClass();
        render();
      });
    });

    widget.querySelectorAll('input[name="selling-plan-radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        syncFreq();
        showError(false);
        closeDropdown();
        render();
      });
    });

    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (dropdown.classList.contains('is-open')) {
          closeDropdown();
        } else {
          openDropdown();
        }
      });
    }

    document.addEventListener('click', function (e) {
      if (dropdown && dropdown.classList.contains('is-open') && !dropdown.contains(e.target)) {
        closeDropdown();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDropdown();
    });

    if (submitBtn) {
      submitBtn.addEventListener('click', function (e) {
        if (needsPlan()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showError(true);
          openDropdown();
        }
      }, true);
    }

    if (minusBtn) {
      minusBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var val = qty();
        if (val > 1) {
          val--;
          qtyInput.value = val;
          savedOTPQuantity = val;
          syncQuantity(val);
          render();
        }
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var val = qty() + 1;
        qtyInput.value = val;
        savedOTPQuantity = val;
        syncQuantity(val);
        render();
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        var val = parseInt(this.value, 10) || 1;
        if (val < 1) val = 1;
        this.value = val;
        savedOTPQuantity = val;
        syncQuantity(val);
        render();
      });
    }

    function watchVariant() {
      var input = document.querySelector('product-form form input[name="id"]')
        || document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (!input) return;
      var value = String(input.value || '');
      if (value && value !== currentVariantId) {
        currentVariantId = value;
        render();
      }
    }

    setInterval(watchVariant, 300);

    setModeClass();
    syncFreq();
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();